export default __webpack_public_path__ + "283101b1e934d8f881a3d97644f46627.woff2";